import { FormlyFieldConfig } from "@ngx-formly/core";

export class AdminCreateUserForm {
  fields: FormlyFieldConfig[];
  model: {};
  actionText = 'button.save';

  constructor(translateService, dataCompanies, user, config?) {

    const companies: {value: string | null, label: string}[] = [];
    for(const company of dataCompanies) companies.push({value: company['_id'], label: company['name'] });

    const roles: {value: string | null, label: string}[] = [];
    roles.push(
      {value: 'sim', label: translateService.instant('role.sim')},
      {value: 'user', label: translateService.instant('role.user')},
      {value: 'admin', label: translateService.instant('role.admin')}
    )
    if (user.roles.includes('superadmin')) roles.push({value: 'superadmin', label: translateService.instant('role.superadmin')})

    this.fields = [
      {
        key: 'name',
        type: 'input',
        wrappers: ['default-wrapper'],
        props: {
          required: true,
        },
        expressions: {
          'props.label': translateService.stream('fields.name')
        }
      },
      {
        key: 'surname',
        type: 'input',
        wrappers: ['default-wrapper'],
        props: {
          required: true
        },
        expressions: {
          'props.label': translateService.stream('fields.surname')
        }
      },
      {
        key: 'email',
        type: 'input',
        wrappers: ['default-wrapper'],
        props: {
          type: 'email',
          required: true
        },
        expressions: {
          'props.label': translateService.stream('fields.email')
        }
      },
      {
        key: 'password',
        type: 'input',
        wrappers: ['default-wrapper'],
        props: {
          type: 'password',
          required: true
        },
        expressions: {
          'props.label': translateService.stream('fields.password')
        }
      },
      {
          key: 'company',
          type: 'select',
          wrappers: ['default-wrapper'],
          hide: !user.roles.includes('superadmin'),
          props: {
              required: true,
              options: companies
          },
          expressions: {
              'props.label': translateService.stream('fields.company')
          }
      },
      {
          key: 'roles',
          type: 'multiselect',
          wrappers: ['default-wrapper'],
          hide: !user.roles.includes('superadmin'),
          props: {
              required: true,
              options: roles
          },
          expressions: {
              'props.label': translateService.stream('fields.roles')
          }
      },
    ]
  }
}

export class AdminEditUserForm {
  fields: FormlyFieldConfig[];
  model: {};
  actionText = 'button.save';

  constructor(translateService, currentUser, dataCompanies, user, config?) {

    const companies: {value: string | null, label: string}[] = [];
    for(const company of dataCompanies) companies.push({value: company['_id'], label: company['name'] });

    const roles: {value: string | null, label: string}[] = [];
    roles.push(
      {value: 'sim', label: translateService.instant('role.sim')},
      {value: 'user', label: translateService.instant('role.user')},
      {value: 'admin', label: translateService.instant('role.admin')}
    )
    if (user.roles.includes('superadmin')) roles.push({value: 'superadmin', label: translateService.instant('role.superadmin')})

    this.fields = [
      {
        key: 'name',
        type: 'input',
        wrappers: ['default-wrapper'],
        defaultValue: currentUser.name,
        props: {
          required: true,
        },
        expressions: {
          'props.label': translateService.stream('fields.name')
        }
      },
      {
        key: 'surname',
        type: 'input',
        wrappers: ['default-wrapper'],
        defaultValue: currentUser.surname,
        props: {
          required: true
        },
        expressions: {
          'props.label': translateService.stream('fields.surname')
        }
      },
      {
          key: 'company',
          type: 'select',
          wrappers: ['default-wrapper'],
          hide: !user.roles.includes('superadmin'),
          defaultValue: currentUser.company._id,
          props: {
              required: true,
              options: companies
          },
          expressions: {
              'props.label': translateService.stream('fields.company')
          }
      },
      {
          key: 'roles',
          type: 'multiselect',
          wrappers: ['default-wrapper'],
          hide: !user.roles.includes('superadmin'),
          defaultValue: currentUser.roles,
          props: {
              required: true,
              options: roles
          },
          expressions: {
              'props.label': translateService.stream('fields.roles')
          }
      },
    ]
  }
}

export class EditUserForm {
  fields: FormlyFieldConfig[];
  model: {};
  actionText = 'button.save';

  constructor(translateService, user, config?) {
    // this.model = measurement;

    this.fields = [
      {
        key: 'name',
        type: 'input',
        wrappers: ['default-wrapper'],
        defaultValue: user.name,
        props: {
          required: true,
        },
        expressions: {
          'props.label': translateService.stream('fields.name')
        }
      },
      {
        key: 'surname',
        type: 'input',
        wrappers: ['default-wrapper'],
        defaultValue: user.surname,
        props: {
          required: true
        },
        expressions: {
          'props.label': translateService.stream('fields.surname')
        }
      },
      {
        key: 'phone',
        type: 'input',
        wrappers: ['default-wrapper'],
        defaultValue: user.phone,
        props: {
          required: true
        },
        expressions: {
          'props.label': translateService.stream('fields.phone')
        }
      },
    ]
  }
}